import React from 'react';
import ReportMessage from './ReportMessage';
import CollectionMessage from './CollectionMessage';

const MessageContent = ({message, onAction}) => {
  if (message.type === 'user') {
    return <div className="text-sm">{message.text}</div>;
  }

  if (message.type === 'error') {
    return <div className="text-sm">{message.text}</div>;
  }

  if (message.type === 'assistant' && message.data) {
    switch (message.data.type) {
      case 'report':
        return <ReportMessage data={message.data} onAction={onAction} />;
      case 'collection':
        return <CollectionMessage data={message.data} onAction={onAction} />;
      default:
        const results =
          message?.data?.reports ??
          message?.data?.data ??
          message?.data?.listings ??
          [];
        return (
          <div className="text-sm">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                {message?.data?.title}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {message?.data?.success_message}
              </p>
            </div>

            {results?.length > 0 && (
              <div className="overflow-auto">
                <table className="min-w-full border-collapse">
                  <thead>
                    <tr className="border-b border-gray-100 bg-gray-50">
                      {results.length > 0 &&
                        Object.keys(results[0]).map(key => (
                          <th
                            key={key}
                            className="text-left py-2 px-2 text-xs font-medium text-gray-500 whitespace-nowrap">
                            {key}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {results?.map((row, index) => (
                      <tr
                        key={index}
                        className={
                          index % 2 === 0 ? 'bg-gray-50/50' : 'bg-white'
                        }>
                        {Object.values(row).map((value, idx) => (
                          <td
                            key={idx}
                            className="py-3 px-2 text-sm text-gray-700 whitespace-nowrap">
                            {value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
    }
  }

  return <div className="text-sm">{message.text}</div>;
};

export default MessageContent;
